module.exports = __webpack_public_path__ + "assets/img/4fbd18cf90655aefa96dc1d665dd4b26.svg";